import React from 'react'
import PropTypes from 'prop-types'
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Box,
    Stack,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import {AddIcon, MinusIcon} from '../icons'
import CustomLink from '../custom-link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const AccordionLink = ({linkGroupSchema}) => {
    const styles = useMultiStyleConfig('Footer')
    const {buildUrl} = useMultiSite()

    return (
        <Stack {...styles.mobileContainer}>
            <Accordion allowMultiple>
                {linkGroupSchema.map(({column_title, links = []}, index) => (
                    <AccordionItem key={index} {...styles.accordionItem}>
                        {({isExpanded}) => (
                            <>
                                <AccordionButton {...styles.accordionButton}>
                                    <Box {...styles.accordionHeading}>{column_title}</Box>
                                    <Box
                                        transform={isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}
                                        transition="transform 0.3s ease"
                                        {...styles.accordionIcon}
                                    >
                                        {isExpanded ? <MinusIcon /> : <AddIcon />}
                                    </Box>
                                </AccordionButton>
                                <AccordionPanel>
                                    <Box>
                                        {links
                                            ?.filter((item) => item.link?.title && item.link?.href)
                                            .map(({link, is_external_url}, index) => {
                                                const isExternalUrl = !!is_external_url
                                                return (
                                                    <Box {...styles.accordionList} key={index}>
                                                        <CustomLink
                                                            isExternal={isExternalUrl}
                                                            href={
                                                                isExternalUrl
                                                                    ? link?.href
                                                                    : buildUrl(link?.href)
                                                            }
                                                            {...styles.links}
                                                        >
                                                            {link?.title}
                                                        </CustomLink>
                                                    </Box>
                                                )
                                            })}
                                    </Box>
                                </AccordionPanel>
                            </>
                        )}
                    </AccordionItem>
                ))}
            </Accordion>
        </Stack>
    )
}
AccordionLink.propTypes = {
    linkGroupSchema: PropTypes.arrayOf(
        PropTypes.shape({
            column_title: PropTypes.string, // Optional if required
            links: PropTypes.arrayOf(
                PropTypes.shape({
                    link: PropTypes.shape({
                        title: PropTypes.string,
                        href: PropTypes.string,
                    }),
                    is_external_url: PropTypes.bool,
                }),
            ),
        }),
    ).isRequired,
}

export default AccordionLink
